import React, { useContext, useState, useEffect, useRef } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatDate, callGameServerApi } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import cards_row from '../assets/cards_row.png';
import logo_wide from '../assets/logo_wide.png';
import { IoEnterOutline } from 'react-icons/io5';
import OneUser from '../ones/OneUser';
import { MdArrowBack } from 'react-icons/md';
import TopBar from '../components/TopBar';
//import WebSocket from 'ws';
import { WEB_SOCKET_URL } from '../Helpers';
import { GAME_TYPES, PLAY_MODES } from '../Constants';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "landscape";
  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const [ gameId, setGameId ] = useState(props.gameId);
  const [ gameData, setGameData ] = useState(null);
  const playMode = PLAY_MODES.ONLINE;

  const webSocketRef = useRef(null);
  

  const play = () => {
    //take to play game
    appContext.navTo({
      item: "play_game",
      subItem: gameId,
    })
  }

  const watch = () => {
    //take to play game
    appContext.navTo({
      item: "watch_game",
      subItem: gameId,
    })
  }

  const acceptOpponent = async (opponent) => {
    setError(false);
    setLoading(true);
    const user = await appContext.getLocalUser();
    await callGameServerApi('accept-join-request', { gameId, opponentId: opponent.userId, ...user, playMode }).then(response => {
      setLoading(false);
      if(response.status === 1) {
        //take to play game
        appContext.navTo({
          item: "play_game",
          subItem: gameId,
        })
      } else {
        appContext.tellError(response.msg);
      }
    })
  }

  const join = async () => {
    if(!loading) {
      setError(false);
      setLoading(true);
      
      const user = await appContext.getLocalUser();
      await callGameServerApi('send-join-request', { gameId, ...user, playMode }).then(async response => {

        if(response.status === 1) {
          setLoading(false);
          
        } else {
          setLoading(false);
          appContext.tellError(response.msg);
        }
      });
    }
  }

  const acceptInvitation = async () => {
    if(!loading) {
      setError(false);
      setLoading(true);
      await callGameServerApi('accept-game-invitation', { gameId }).then(async response => {

        if(response.status === 1) {
          await getGameData().then(response => {
            if(response.status === 1) {
              setGameData(response.gameData);
              setLoading(false);
              //take to play game
              appContext.navTo({
                item: "play_game",
                subItem: gameId,
              })
            } else {
              setLoading(false);
              appContext.tellError(response.msg);
            }
          })
        } else {
          setLoading(false);
          appContext.tellError(response.msg);
        }
      });
    }
  }

  const init = async () => {
    console.log("Browse game start");
    setLoading(true);
    await  getGameData().then((response) => {
      if(response.status === 1) {
        setGameData(response.gameData)

        //subscribe for game data updates
        webSocketRef.current = new WebSocket(WEB_SOCKET_URL);
        webSocketRef.current.addEventListener('open', async () => {
          //send subscription message
          // using delay hack
          setTimeout(async () => {
            if(webSocketRef.current.readyState === WebSocket.OPEN) {
              let user = await appContext.getLocalUser();
              webSocketRef.current.send(JSON.stringify({
                type: 'subscribe-for-game-data',
                gameId,
                userId: user.userId,
                userToken: user.userToken,
                sourceId: 'browseGame',
              }))
            }
          }, 3000);
        })

        webSocketRef.current.addEventListener('message', (e) => {
          const response = JSON.parse(e.data);
          setGameData(response.gameData);
        })

        setLoading(false);
        setReady(true);
      } else {
        setGameData(null);
        appContext.tellError(response.msg)
      }

    })
    

  }

  const getGameData = async () => {
    return new Promise( async resolve => {
      setError(false);
      await callGameServerApi('get-game-data', { gameId }).then(response => resolve(response))
    })
  }

  const socketCloser = async () => {

    //send unsubscribe req 
    if(webSocketRef.current.readyState === WebSocket.OPEN) {
      let user = await appContext.getLocalUser();
      webSocketRef.current.send(JSON.stringify({
        type: 'unsubscribe-for-game-data',
        gameId,
        userId: user.userId,
        userToken: user.userToken,
        sourceId: 'browseGame',
      }))
    }

    //then close connection
    if(webSocketRef.current) {
      webSocketRef.current.close();
    }
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();

    } else {
      //take to common area
      appContext.openLogin();
    }

    return () => {
      socketCloser();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    setGameId(props.gameId);
  }, [ props.gameId ]);

  useEffect(() => {
    init();
  }, [ gameId ]);

  useEffect(() => {
    //..
  }, [ gameData ]);

  if(ready && gameData) {

    return (
      <>
        <TopBar title="Game"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className='container'>
            <div className='row'>

              <div className='col-md-12 mNoPad' style={{ position: "relative", height: "50vh", overflow: "hidden" }}>
                {
                  (gameData.type === GAME_TYPES.LASTCARD || gameData.type === GAME_TYPES.ARUBASTINI) ?
                  <img src={cards_row} className="mBackImg" style={{ zIndex: "2", }}/>
                  :""
                }

                {
                  (gameData.type === GAME_TYPES.SPANISH_CHECKERS || gameData.type === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                  <img src={chess_pieces} className="mBackImg" style={{ zIndex: "2", }}/>
                  :""
                }
                <div className='container-fluid mNoMargin' style={{ position: 'absolute', top: "0", paddingTop: "40px" }}>
                  <div className='row'>

                    <div className='col-12 text-center'>
                      <img src={logo_wide} style={{ width: "300px", height: "auto" }}/>
                    </div>
                    <div className='col-12 text-redish'>
                      {
                        (gameData.type === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                        <h3 style={{ padding: "20px" }} className='font-light text-center bg-faint-black'>Brazilian Checkers</h3>
                        :""
                      }

                      {
                        (gameData.type === GAME_TYPES.SPANISH_CHECKERS) ?
                        <h3 style={{ padding: "20px" }} className='font-light text-center bg-faint-black'>Spanish Checkers</h3>
                        :""
                      }

                      {
                        (gameData.type === 'lastcard') ?
                        <h3 style={{ padding: "20px" }} className='font-light text-center bg-faint-black'>Cards - LastCard</h3>
                        :""
                      }

                      {
                        (gameData.type === 'arubastini') ?
                        <h3 style={{ padding: "20px" }} className='font-light text-center bg-faint-black'>Cards - Arubastini</h3>
                        :""
                      }
                      
                    </div>
                    {
                      (error) ?
                      <div className='col-12 text-center text-redish'>
                        <small>{error}</small>
                      </div>: ""
                    }

                    {
                      (gameData) ?
                      <div className='col-12 text-center' style={{ marginTop: "20px" }}>

                        {
                          (gameData.status === 'completed') ?
                          <p className="font-light" style={{ fontSize: "14px" }}>{gameData.completionReason}</p>: ""
                        }

                        {
                          (gameData.playerId === appContext.userData.id && (gameData.status === 'joined' || gameData.status === 'ongoing')) ?
                          <p className="font-light" style={{ fontSize: "14px" }}>An opponent joined your game, click 'Play' button to start playing</p>: ""
                        }

                        {
                          (gameData.opponentId === appContext.userData.id && (gameData.status === 'joined' || gameData.status === 'ongoing')) ?
                          <p className="font-light" style={{ fontSize: "14px" }}>Your joining request was accepted, click 'Play' button to start playing</p>: ""
                        }

                        {
                          ((gameData.playerId === appContext.userData.id || gameData.opponentId === appContext.userData.id) && gameData.status !== 'completed' && gameData.status !== 'superdraw') ?
                          <button onClick={play} className='btn bg-goldish'>Play</button>
                          :""
                        }

                        {/*
                          (gameData.playerId !== appContext.userData.id && gameData.opponentId !== appContext.userData.id && gameData.status !== 'completed' && gameData.status !== 'superdraw' ) ?
                          <button onClick={watch} className='btn bg-redish'>Watch</button>
                          :""
                        */}

                        {
                          (gameData.playerId !== appContext.userData.id && gameData.opponentId !== appContext.userData.id && gameData.invitedId !== appContext.userData.id && gameData.status === "hosted") ?
                          <button onClick={() => {
                            appContext.activateDialog({
                              message: "Do you want to join this game?",
                              onConfirm: join,
                            })
                          }} className='btn bg-bluish'>
                            Request to Join
                          </button>
                          :""
                        }

                        {
                          (gameData.invitedId && gameData.invitedId === appContext.userData.id && gameData.status === "hosted") ?
                          <button onClick={() => {
                            appContext.activateDialog({
                              message: "Accept invitation and join this game?",
                              onConfirm: acceptInvitation,
                            })
                          }} className='btn bg-faint-black'>
                            You were invited, Click to Accept
                          </button>
                          :""
                        }

                        {
                          (gameData.status === 'completed') ? <h1>Game Over!</h1> : ""
                        }

                        {
                          (gameData.status === 'superdraw') ? <h1>Game Draw!</h1> : ""
                        }
                      </div> :
                      <div className='col-12 text-center' style={{ marginTop: "20px" }}>
                        <button onClick={appContext.openHome} className='btn bg-faint-black'>Home</button>
                      </div>
                    }

                  </div>
                </div>
              </div>

              {
                (gameData.status === 'hosted') ?
                <div className='col-md-6' style={{ marginTop: "20px", paddingTop: "10px", marginBottom: "30px" }}>
                  <h5 className='text-muted'>Joining Requests ({JSON.parse(gameData.joinRequests).length})</h5>
                  <hr/>
                  {
                    (JSON.parse(gameData.joinRequests).length > 0) ?
                    JSON.parse(gameData.joinRequests).map((item, i) => {
                      return (
                        <div key={i} className='text-start'>
                          <h6>{item.username}</h6>
                          <small className='text-muted'>Points: <span className='text-goldish'>{item.points}</span></small>
                          {
                            (appContext.userData.id === gameData.playerId && gameData.status === 'hosted') ?
                            <div className='text-end'>
                              <button
                                onClick={() => appContext.activateDialog({
                                  message: `Accept ${item.username} to join you in this game?`,
                                  onConfirm: () => {
                                    acceptOpponent(item)
                                  }
                                })}
                                className='btn bg-bluish btn-rounded btn-sm'>
                                Accept
                              </button>
                            </div>: ""
                          }
                          <hr/>
                        </div>
                      )
                    }):
                    <div className='text-start'>
                      <small className='font-light'>No requests were found</small>
                    </div>
                  }
                </div> : ""
              }

              <div className='col-md-6' style={{ paddingTop: "20px" }}>
                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Game ID: &nbsp;<span className='text-light font-regular' style={{ fontSize: "20px" }}>{gameData.uid}</span>
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Hosted By: &nbsp;<OneUser id={gameData.playerInfo.id} username={gameData.playerInfo.username} simple={true}/>
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Guest: &nbsp;{gameData.opponentInfo ? <OneUser id={gameData.opponentInfo.id} username={gameData.opponentInfo.username} simple={true}/> : "N/A"}
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Invited User: &nbsp;{gameData.invitedInfo ? <OneUser id={gameData.invitedInfo.id} username={gameData.invitedInfo.username} simple={true}/> : "N/A"}
                </h6>


                <hr/>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Status: &nbsp;
                  <span className='text-goldish font-light'>
                    {
                      (gameData.status === 'hosted') ?
                      "Waiting for guest to join......"
                      :
                      (gameData.status === 'joined') ?
                      "Guest Joined"
                      :
                      gameData.status
                    }
                  </span>
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Created On: &nbsp;<span className='text-goldish font-light'>{formatDate(gameData.dateCreated)}</span>
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Number of draws: &nbsp;<span className='text-goldish font-light'>{gameData.drawsNumber}</span>
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  Winner: &nbsp;<span className='text-goldish font-light'>{(gameData.winnerInfo) ? gameData.winnerInfo.username : "N/A"}</span>
                </h6>

                <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                  League: &nbsp;<span className='text-goldish font-light'>{(gameData.leagueInfo) ? gameData.leagueInfo.title : "N/A"}</span>
                </h6>
              </div>

              

            </div>
          </div>
        </div>
      </>
    )

  } else {
    return <></>;
  }
}
